import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import DashboardSidebar from './components/DashboardSidebar';
import ProfileSection from './components/ProfileSection';
import PreferencesSection from './components/PreferencesSection';
import DashboardContent from './components/DashboardContent';
import Icon from '../../components/AppIcon';

const UserDashboardCleanMobileLayout = () => {
  const [activeSection, setActiveSection] = useState('profile');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const renderContent = () => {
    switch (activeSection) {
      case 'profile':
        return <ProfileSection />;
      case 'preferences':
        return <PreferencesSection />;
      case 'checklist':
        return <DashboardContent title="Wedding Checklist" content="Wedding checklist features coming soon..." />;
      case 'vendors':
        return <DashboardContent title="Saved Vendors" content="Saved vendors management coming soon..." />;
      case 'messages':
        return <DashboardContent title="Messages" content="Message center coming soon..." />;
      case 'registry':
        return <DashboardContent title="Gift Registry" content="Gift registry features coming soon..." />;
      case 'settings':
        return <DashboardContent title="Settings" content="Account settings coming soon..." />;
      default:
        return <ProfileSection />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="flex pt-16">
        {/* Sidebar */}
        <DashboardSidebar
          activeSection={activeSection}
          setActiveSection={setActiveSection}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />

        {/* Mobile overlay */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Main content */}
        <main className="flex-1 lg:ml-64">
          {/* Mobile header */}
          <div className="lg:hidden flex items-center justify-between p-4 bg-surface border-b border-border">
            <button
              onClick={() => setSidebarOpen(true)}
              className="p-2 rounded-lg bg-surface-100 hover:bg-surface-200 transition-colors"
            >
              <Icon name="Menu" size={20} />
            </button>
            <h1 className="text-lg font-semibold text-text-primary">Dashboard</h1>
            <div className="w-10" />
          </div>

          {/* Content */}
          <div className="p-4 lg:p-6 max-w-4xl mx-auto">
            {renderContent()}
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default UserDashboardCleanMobileLayout;